import { useUserDetailContext } from "../../../UserDetailContext";
import MyfeedInfo from "../UserProfileInfo/MyfeedInfo";
import MyPosts from "../UserProfileInfo/MyPosts";
import UserCompo from "../UserProfileInfo/UserCompo";
import VolunteerDetailPage from "./VolunteerDetailPage";

const VolunteerDetailMainScreen = () => {
  const isAuth = localStorage.getItem('objectId');
  const showSidebar = Boolean(isAuth); // cleaner boolean conversion

  return (
    <div
      style={{
        display: "flex",
        justifyContent: showSidebar ? "flex-start" : "center",
        width: "100%",
        padding: "20px",
         height: showSidebar ?  "85vh" :"100vh",
        backgroundColor: "#F4F7FE",
        overflow: "hidden",
        
      }}
    >
      {showSidebar && (
        <div
          style={{
            width: "25%",
            textAlign: "left",
            margin: "5px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              minHeight: "80vh",
              overflowY: "scroll",
              scrollbarWidth: "none",
              scrollBehavior: "smooth",
            }}
          >
            <UserCompo />
            <MyPosts />
            <MyfeedInfo />
          </div>
        </div>
      )}

      <div
        style={{
          width: showSidebar ? "70%" : "100%",
          display: "flex",
          flexDirection: "column",
          position: "relative",
          height: showSidebar ?  "80vh" :"100vh",
          
        }}
      >
        <div
          style={{
            height: showSidebar ?  "80vh" :"100vh",
            overflowY: "scroll",
            scrollbarWidth: "none",
            justifyContent: "center",
            display: "flex",
          }}
        >
        <VolunteerDetailPage/>
        </div>
      </div>
    </div>
  );
};

export default VolunteerDetailMainScreen;
